import React from 'react';

/*
What the event list shows, for the shared DataTable.

Sorting is server-side, so only the fields the backend whitelists are marked
sortable.
*/
const eventColumns = handleClick => [
  { field: '_id', headerName: 'id', type: 'string', hide: true, isId: true },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'left',
    content: rowData => (
      <span
        className="font-icon icon-edit text-20 cursor-pointer"
        title="Edit event"
        onClick={() => handleClick('modify', rowData.eventSlugName)}
      />
    ),
  },
  { field: 'eventName', headerName: 'name', type: 'string', sortable: true, align: 'left' },
  { field: 'eventSlugName', headerName: 'slug', type: 'string', sortable: true, align: 'left' },
  { field: 'beginDateTime', headerName: 'begins', type: 'date', sortable: true, align: 'left' },
  { field: 'endDateTime', headerName: 'ends', type: 'date', sortable: true, align: 'left' },
  {
    field: 'tickets',
    headerName: 'tickets',
    type: 'action',
    align: 'right',
    description: 'How many tickets this event lists',
    content: rowData => ((rowData.tickets || []).length || ''),
  },
  { field: 'totalCapacity', headerName: 'capacity', type: 'string', align: 'right' },
  { field: 'createdAt', headerName: 'created', type: 'date', sortable: true, align: 'left', description: 'When the record was created' },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'right',
    content: rowData => (
      <span
        className="font-icon icon-trash text-20 cursor-pointer"
        title="Delete event"
        onClick={() => handleClick('delete', rowData.eventSlugName)}
      />
    ),
  },
];

export default eventColumns;
